(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.eventListener = factory();
  }
})(this, function () {
  function wrap(standard, fallback) {
    return function (el, evtName, listener, useCapture) {
      if (el[standard]) {
        el[standard](evtName, listener, useCapture);
      } else if (el[fallback]) {
        el[fallback]('on' + evtName, listener);
      }
    };
  }

  return {
    add: wrap('addEventListener', 'attachEvent'),
    remove: wrap('removeEventListener', 'detachEvent')
  };
});